import type { FormFields, FormErrors } from './formFields'

import { useEffect } from 'react'
import { Box } from '@mui/material'

import { FormValues, useFormMeta } from '@workwave-tidal/form-fairy'
import { Form, FormHeader } from '@workwave-tidal/form-ui/layout'

import { useOnSubmit } from './hooks/useOnSubmit'
import { useTexts } from './hooks/useTexts'

import { FormFooter } from './components/FormFooter'

import { DistanceFormat } from './components/fields/DistanceFormat'
import { DateFormat } from './components/fields/DateFormat'
import { TimeFormat } from './components/fields/TimeFormat'

type Props = {
  onDiscard: () => void
  updateFormats: (data: FormValues<FormFields>) => Promise<boolean>
}

export function GpsFormatsForm(props: Props) {
  const { onDiscard, updateFormats } = props

  const texts = useTexts()

  const {
    meta: { submitting },
    api,
  } = useFormMeta<FormFields, FormErrors>()

  // create a submit function linked to
  // - the domain update function
  // - the form API
  // - the application editing status
  const onSubmit = useOnSubmit(updateFormats, onDiscard)

  useEffect(() => {
    api.validate()
  }, [api])

  return (
    <Box width={360} height="100%" data-testid="form__column-secondary" display="flex" paddingY={2}>
      <Form
        header={<FormHeader title={texts.headerTitle} subtitle={texts.headerDescription} />}
        footer={<FormFooter onDiscard={onDiscard} onSubmit={onSubmit} submitting={submitting} />}
        testId="gps-formats-form"
        onEnter={onSubmit}
        disableScroll
        fieldsSpacing={4}
        fieldsPadding="0 32px"
      >
        <DateFormat />

        <TimeFormat />

        <DistanceFormat />
      </Form>
    </Box>
  )
}
